import { render } from "./JobFeedbackMention.vue?vue&type=template&id=a04cc2e6"
import script from "./JobFeedbackMention.vue?vue&type=script&lang=js"
export * from "./JobFeedbackMention.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__